import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, RefreshCwIcon, BriefcaseIcon, GraduationCapIcon, SparklesIcon, ArrowRightIcon } from 'lucide-react';
const benefits = [{
  Icon: BookOpenIcon,
  title: 'Más de 300 Sesiones',
  desc: 'Planificaciones listas para usar, paso a paso, de todos los niveles.',
  tag: '300+ planes',
  accent: 'from-blue-500 to-cyan-400',
  glow: 'shadow-blue-500/20',
  iconColor: 'text-blue-400',
  iconBg: 'bg-blue-500/10',
  borderHover: 'group-hover:border-blue-500/50'
}, {
  Icon: RefreshCwIcon,
  title: 'Metodología R.E.A.',
  desc: 'Sistema de Repetición, Estímulo y Avance para resultados rápidos.',
  tag: 'Probado',
  accent: 'from-emerald-500 to-green-400',
  glow: 'shadow-emerald-500/20',
  iconColor: 'text-emerald-400',
  iconBg: 'bg-emerald-500/10',
  borderHover: 'group-hover:border-emerald-500/50'
}, {
  Icon: BriefcaseIcon,
  title: 'Gestión "Business Pro"',
  desc: 'Herramientas para manejar grupos mixtos y atraer alumnos particulares.',
  tag: '+ ingresos',
  accent: 'from-purple-500 to-fuchsia-400',
  glow: 'shadow-purple-500/20',
  iconColor: 'text-purple-400',
  iconBg: 'bg-purple-500/10',
  borderHover: 'group-hover:border-purple-500/50'
}, {
  Icon: GraduationCapIcon,
  title: 'Certificado EDULABS™',
  desc: 'Un certificado que avala el uso de metodología pedagógica avanzada.',
  tag: 'Exclusivo',
  accent: 'from-amber-500 to-orange-400',
  glow: 'shadow-amber-500/20',
  iconColor: 'text-amber-400',
  iconBg: 'bg-amber-500/10',
  borderHover: 'group-hover:border-amber-500/50'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-main py-24 px-4 relative overflow-hidden" data-id="element-1">
      {/* Decorative background blobs */}
      <div aria-hidden className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-3xl pointer-events-none" data-id="element-2" />
      <div aria-hidden className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-secondary/5 rounded-full blur-3xl pointer-events-none" data-id="element-3" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-4">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-5">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 border border-primary/20 mb-6" data-id="element-6">
            <SparklesIcon className="w-4 h-4 text-primary" data-id="element-7" />
            <span className="text-sm font-semibold text-primary tracking-wide uppercase" data-id="element-8">
              Lo que incluye
            </span>
          </div>

          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-text-main mb-5 tracking-tight" data-id="element-9">
            Qué obtendrás
          </h2>
          <p className="text-xl sm:text-2xl font-bold text-text-main max-w-3xl mx-auto mb-3" data-id="element-10">
            Todo lo que necesitas para enseñar natación{' '}
            <span className="text-primary" data-id="element-11">sin más estrés</span>.
          </p>
          <p className="text-text-sec text-lg max-w-2xl mx-auto" data-id="element-12">
            Cuatro pilares pensados para ahorrarte horas y hacer brillar tus
            clases.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-6" data-id="element-13">
          {benefits.map((benefit, i) => {
          const {
            Icon
          } = benefit;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} whileHover={{
            y: -6
          }} className={`group relative bg-bg-alt p-8 rounded-3xl border border-border-light overflow-hidden transition-all duration-300 hover:shadow-2xl ${benefit.glow} ${benefit.borderHover}`} data-id="element-14">
                {/* Gradient accent line at top */}
                <div className={`absolute top-0 left-0 right-0 h-1 bg-gradient-to-r ${benefit.accent} opacity-60 group-hover:opacity-100 transition-opacity duration-300`} data-id="element-15" />

                {/* Subtle gradient glow on hover */}
                <div className={`absolute -top-20 -right-20 w-40 h-40 rounded-full bg-gradient-to-br ${benefit.accent} opacity-0 group-hover:opacity-10 blur-3xl transition-opacity duration-500 pointer-events-none`} data-id="element-16" />

                {/* Step number */}
                <div className="absolute top-6 right-6 text-7xl font-black text-text-main/[0.04] leading-none select-none" data-id="element-17">
                  0{i + 1}
                </div>

                <div className="relative z-10 flex flex-col gap-4" data-id="element-18">
                  <div className="flex items-start justify-between gap-4" data-id="element-19">
                    <div className={`w-14 h-14 rounded-2xl ${benefit.iconBg} border border-border-light flex items-center justify-center ${benefit.iconColor} group-hover:scale-110 transition-transform duration-300`} data-id="element-20">
                      <Icon className="w-7 h-7" strokeWidth={2} data-id="element-21" />
                    </div>
                    <span className={`mt-2 text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full ${benefit.iconBg} ${benefit.iconColor} border border-border-light whitespace-nowrap`} data-id="element-22">
                      {benefit.tag}
                    </span>
                  </div>

                  <h3 className="text-2xl font-bold text-text-main mt-2" data-id="element-23">
                    {benefit.title}
                  </h3>
                  <p className="text-text-sec leading-relaxed text-base sm:text-lg" data-id="element-24">
                    {benefit.desc}
                  </p>

                  {/* Hover arrow */}
                  <div className={`flex items-center gap-2 mt-2 ${benefit.iconColor} opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300`} data-id="element-25">
                    <span className="text-sm font-semibold" data-id="element-26">
                      Incluido en el pack
                    </span>
                    <ArrowRightIcon className="w-4 h-4" data-id="element-27" />
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}